function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.23,7.63H15.64v-.8a3,3,0,0,0-3-3H11.34a3,3,0,0,0-3,3v.8H5.77A2.18,2.18,0,0,0,3.6,9.8V18a2.17,2.17,0,0,0,2.17,2.16H18.23A2.17,2.17,0,0,0,20.4,18V9.8A2.18,2.18,0,0,0,18.23,7.63ZM10,6.83a1.36,1.36,0,0,1,1.35-1.35h1.32A1.36,1.36,0,0,1,14,6.83v.8H10Zm5.28,7.61H12.82V16.9H11.18V14.44H8.73V12.8h2.45V10.35h1.64V12.8h2.45Z",
    style: {
      fill: "#d45151"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon);
export default __webpack_public_path__ + "static/media/safety_icon.7e2cd5e4fa3e5ac8637c3791f0bf6708.svg";
export { ForwardRef as ReactComponent };